/* ══════════════════════════════════════════════════════════════════
   FEATURED WRITINGS — generated by fw-src/build-shopify.py. Do not edit.
   ⚠ EVERY SECTION EMITS ITS OWN <script src>, so the guard makes the module
   run exactly once however many sections are on the page.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twsFwInit) return;
  window.__twsFwInit = true;

/* ═══════════ FEATURED WRITINGS — filter, count and load-more ═══════════
   ⚠ EVERY PIECE IS IN THE DOM. Server-side filtering is not available for
   metaobjects, so the chips and the pager both work over the rendered list —
   the same pattern shop.html and tws-blog-grid.liquid already use. That also
   means `?genre=` deep links from the mega menu work with no extra plumbing. */
(function () {
  /* ⚠ ROOT AT THE SECTION, NOT AT `.tws-fw`. Locally there is ONE `.tws-fw`
     wrapping all three sections; on the theme each section emits its OWN, so
     `document.querySelector('.tws-fw')` returns the HERO. Everything below it
     then found nothing, `.fw-count` came back null, and the whole module threw
     on the first assignment — filters dead, pager dead, all 29 rows showing.
     `#listing` is the one element that means the same thing in both. */
  var root = document.querySelector('#listing');
  if (!root) return;
  var PAGE = 16;
  var rows = [].slice.call(root.querySelectorAll('.fw-row'));
  var chips = [].slice.call(root.querySelectorAll('.fw-chip'));
  var countEl = root.querySelector('.fw-count');
  var noteEl = root.querySelector('.fw-note');
  var pageEl = root.querySelector('.fw-page');
  var moreBtn = root.querySelector('.fw-more');
  var footEl = root.querySelector('.fw-foot');
  var filter = 'All', shown = PAGE;

  function slug(s) { return (s || '').toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, ''); }


  function apply() {
    var match = rows.filter(function (r) {
      return filter === 'All' || r.getAttribute('data-genre') === filter;
    });
    rows.forEach(function (r) { r.hidden = true; });
    match.slice(0, shown).forEach(function (r, i) {
      r.hidden = false;
      // zig-zag by VISIBLE position, so filtering never stacks two artworks
      // down the same side
      r.classList.toggle('is-flip', i % 2 === 1);
    });

    var n = match.length;
    countEl.textContent = n === 1 ? '1 piece' : n + ' pieces';
    // the honest note while `genre` does not exist on the metaobject yet
    var unfiled = rows.filter(function (r) { return r.getAttribute('data-genre') === 'Unfiled'; }).length;
    noteEl.textContent = (filter === 'All' && unfiled)
      ? unfiled + ' not yet filed by genre' : '';   // empty now every piece has one

    footEl.hidden = n === 0;
    moreBtn.hidden = shown >= n;
    pageEl.textContent = n ? 'Showing ' + Math.min(shown, n) + ' of ' + n : '';
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      filter = c.getAttribute('data-filter');
      shown = PAGE;
      chips.forEach(function (o) {
        var on = o === c;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var u = new URL(location.href);
      if (filter === 'All') u.searchParams.delete('genre');
      else u.searchParams.set('genre', slug(filter));
      history.replaceState(null, '', u);
      apply();
    });
  });

  moreBtn.addEventListener('click', function () { shown += PAGE; apply(); });

  // ?genre=poetry from the mega menu
  var want = new URLSearchParams(location.search).get('genre');
  if (want) {
    var hit = chips.filter(function (c) { return slug(c.getAttribute('data-filter')) === want; })[0];
    if (hit) { hit.click(); return; }
  }
  apply();
})();

})();
